import AssignmentSelector from './AssignmentSelector';

export default AssignmentSelector;
